// removed by extract-text-webpack-plugin
module.exports = {"signature":"cYIYTfbqAzPnBA-Siu8Fe"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Document/Page/Field/Edit/Signature/Image/styles.css
// module id = 2929
// module chunks = 0